import React from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../app/store/slices/uiSlice";
import { Modal } from "./index"; // You already have a Modal component

const ConfirmModal = ({ isOpen, title = "Confirm Action", message = "Are you sure you want to proceed?", confirmLabel = "Confirm", cancelLabel = "Cancel", onConfirm, onCancel, isLoading = false }) => {
  const darkMode = useSelector(selectDarkMode);

  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title} size="sm">
      <div className="space-y-4">
        <p className={`text-sm font-normal text-center mt-3 ${darkMode ? "text-gray-300" : "text-[#232526]"}`}>{message}</p>

        <div className="flex justify-center space-x-3 pt-4">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className={`border rounded-xl font-base font-semibold px-10 py-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${darkMode ? "border-gray-600 text-gray-300 hover:bg-gray-700" : "border-[#F0EFEF] text-[#232526] hover:bg-gray-50"}`}
          >
            {cancelLabel}
          </button>
          <button onClick={onConfirm} disabled={isLoading} className="bg-[#EC432D] hover:bg-red-600 px-10 py-3 rounded-xl text-white font-base font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
            {isLoading && (
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            )}
            {isLoading ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
